"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterBar = FilterBar;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _MessageStrip = _interopRequireDefault(require("@concur/nui-widgets/lib/MessageStrip/MessageStrip"));
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _Checkbox = _interopRequireDefault(require("@concur/nui-widgets/lib/Forms/Checkbox"));
var _Categories = _interopRequireDefault(require("./Categories"));
var _Products = _interopRequireDefault(require("./Products"));
var _Countries = _interopRequireDefault(require("./Countries"));
var _Regions = _interopRequireDefault(require("./Regions"));
var _listingsModule = require("../listingsModule");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function FilterBar(_ref) {
  var flattenedCategories = _ref.flattenedCategories,
    selectedCategories = _ref.selectedCategories,
    flattenCategories = _ref.flattenCategories,
    offeringsEnabled = _ref.offeringsEnabled,
    selectedProducts = _ref.selectedProducts,
    countries = _ref.countries,
    selectedCountries = _ref.selectedCountries,
    regions = _ref.regions,
    selectedRegions = _ref.selectedRegions,
    formatter = _ref.formatter,
    setInitialFilterValues = _ref.setInitialFilterValues,
    applyListingFilters = _ref.applyListingFilters,
    setMainFilterValues = _ref.setMainFilterValues,
    profile = _ref.profile,
    isPublic = _ref.isPublic,
    setShowNewlyReleasedApps = _ref.setShowNewlyReleasedApps,
    showNewlyReleasedApps = _ref.showNewlyReleasedApps,
    setShowUnlocalizedListings = _ref.setShowUnlocalizedListings,
    showUnlocalizedListings = _ref.showUnlocalizedListings,
    country = _ref.country,
    firstListingsPageLoadComplete = _ref.firstListingsPageLoadComplete;
  if (!flattenedCategories) {
    flattenCategories();
    return null;
  }
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    newlyReleaasedAnnounce = _useState2[0],
    setNewlyReleaasedAnnounce = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    unlocalizedAnnounce = _useState4[0],
    setUnlocalizedAnnounce = _useState4[1];
  (0, _react.useEffect)(function () {
    if (!firstListingsPageLoadComplete) {
      setInitialFilterValues({
        localizedRegions: regions,
        localizedCountries: countries,
        profile: profile,
        offeringsEnabled: offeringsEnabled,
        country: country
      });
      applyListingFilters({
        doNotModifyUrl: true
      });
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (showNewlyReleasedApps) {
      setNewlyReleaasedAnnounce(formatter.formattedMessage({
        id: 'AppCenterV2.home.filters.newlyReleasedAppsToggle.announcement.selected'
      }));
    } else {
      setNewlyReleaasedAnnounce(formatter.formattedMessage({
        id: 'AppCenterV2.home.filters.newlyReleasedAppsToggle.announcement.deselected'
      }));
    }
  }, [showNewlyReleasedApps]);
  (0, _react.useEffect)(function () {
    if (showUnlocalizedListings) {
      setUnlocalizedAnnounce(formatter.formattedMessage({
        id: 'AppCenterV2.home.filters.localizedToggle.language.selected'
      }));
    } else {
      setUnlocalizedAnnounce(formatter.formattedMessage({
        id: 'AppCenterV2.home.filters.localizedToggle.language.deselected'
      }));
    }
  }, [showUnlocalizedListings]);
  function updateCategoryFilter(categoryFilter) {
    setMainFilterValues({
      categoryFilter: categoryFilter
    });
    applyListingFilters();
  }
  function updateProductFilter(productFilter) {
    setMainFilterValues({
      productFilter: productFilter
    });
    applyListingFilters();
  }
  function updateCountryFilter(countryFilter) {
    setMainFilterValues({
      countryFilter: countryFilter
    });
    applyListingFilters();
  }
  function updateRegionFilter(regionFilter) {
    setMainFilterValues({
      regionFilter: regionFilter
    });
    applyListingFilters();
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "row filter-bar-row",
    style: {
      marginBottom: '32px'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 col-sm-6 col-lg-3 "
  }, /*#__PURE__*/_react.default.createElement(_Categories.default, {
    flattenedCategories: flattenedCategories,
    value: selectedCategories,
    onSelect: updateCategoryFilter
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 col-sm-6 col-lg-3 "
  }, /*#__PURE__*/_react.default.createElement(_Products.default, {
    offeringsEnabled: offeringsEnabled,
    onSelect: updateProductFilter,
    value: selectedProducts,
    isPublic: isPublic
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 col-sm-6 col-lg-3 "
  }, /*#__PURE__*/_react.default.createElement(_Countries.default, {
    countries: countries,
    value: selectedCountries,
    onSelect: updateCountryFilter
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 col-sm-6 col-lg-3 "
  }, /*#__PURE__*/_react.default.createElement(_Regions.default, {
    regions: regions,
    value: selectedRegions,
    onSelect: updateRegionFilter
  }))), offeringsEnabled && selectedProducts.some(function (product) {
    return !offeringsEnabled.some(function (offering) {
      return offering === product.id;
    });
  }) && /*#__PURE__*/_react.default.createElement(_MessageStrip.default, {
    typeLabel: formatter.formattedMessage({
      id: 'CoreUIComponents.warning'
    }),
    message: formatter.formattedMessage({
      id: 'AppCenterV2.home.filters.compatibilityWarning'
    }),
    type: "warning",
    style: {
      marginBottom: '24px'
    }
  }), /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    label: formatter.formattedMessage({
      id: 'AppCenterV2.home.filters.newlyReleasedAppsToggle.label'
    }),
    checked: showNewlyReleasedApps,
    onChange: function onChange(checked) {
      setShowNewlyReleasedApps(checked);
      applyListingFilters();
    },
    labelProps: {
      'data-testid': 'newly-released-apps-checkbox'
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    id: "announce-newly-released",
    "aria-live": "polite",
    role: "status",
    style: {
      position: 'absolute',
      top: 0,
      left: '-10000px'
    }
  }, newlyReleaasedAnnounce), (!isPublic || country !== 'US') && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    label: formatter.formattedMessage({
      id: 'AppCenterV2.home.filters.localizedToggle.label3'
    }),
    checked: showUnlocalizedListings,
    onChange: function onChange(checked) {
      setShowUnlocalizedListings(checked);
      applyListingFilters();
    },
    labelProps: {
      'data-testid': 'unlocalized-listings-checkbox'
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    id: "announce-unlocalized",
    "aria-live": "polite",
    role: "status",
    style: {
      position: 'absolute',
      top: 0,
      left: '-10000px'
    }
  }, unlocalizedAnnounce)));
}
FilterBar.propTypes = {
  flattenedCategories: _propTypes.default.arrayOf(_propTypes.default.object),
  selectedCategories: _propTypes.default.arrayOf(_propTypes.default.object),
  selectedProducts: _propTypes.default.arrayOf(_propTypes.default.object),
  flattenCategories: _propTypes.default.func.isRequired,
  offeringsEnabled: _propTypes.default.arrayOf(_propTypes.default.string),
  countries: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  selectedCountries: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  regions: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  selectedRegions: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  formatter: _propTypes.default.shape({
    formattedMessage: _propTypes.default.func.isRequired
  }).isRequired,
  setInitialFilterValues: _propTypes.default.func.isRequired,
  profile: _propTypes.default.object.isRequired,
  isPublic: _propTypes.default.bool,
  setMainFilterValues: _propTypes.default.func.isRequired,
  applyListingFilters: _propTypes.default.func.isRequired,
  showUnlocalizedListings: _propTypes.default.bool,
  setShowUnlocalizedListings: _propTypes.default.func.isRequired,
  showNewlyReleasedApps: _propTypes.default.bool,
  setShowNewlyReleasedApps: _propTypes.default.func.isRequired,
  country: _propTypes.default.string,
  firstListingsPageLoadComplete: _propTypes.default.bool
};
function mapStateToProps(state) {
  var _state$userProfile, _state$meta, _state$meta2;
  return {
    flattenedCategories: state.listings.flattenedCategories,
    selectedCategories: state.listings.categoryFilter,
    selectedProducts: state.listings.productFilter,
    offeringsEnabled: (_state$userProfile = state.userProfile) === null || _state$userProfile === void 0 ? void 0 : _state$userProfile.offeringsEnabled,
    profile: state.userProfile.profile,
    countries: state.listing.localizedCountries,
    selectedCountries: state.listings.countryFilter,
    regions: state.listing.localizedRegions,
    selectedRegions: state.listings.regionFilter,
    isPublic: (_state$meta = state.meta) === null || _state$meta === void 0 ? void 0 : _state$meta.isPublic,
    showUnlocalizedListings: state.listings.showUnlocalizedListings,
    showNewlyReleasedApps: state.listings.showNewlyReleasedApps,
    country: (_state$meta2 = state.meta) === null || _state$meta2 === void 0 ? void 0 : _state$meta2.country,
    firstListingsPageLoadComplete: state.listings.firstListingsPageLoadComplete
  };
}
var mapDispatchToProps = {
  flattenCategories: _listingsModule.flattenCategories,
  setInitialFilterValues: _listingsModule.setInitialFilterValues,
  applyListingFilters: _listingsModule.applyListingFilters,
  setMainFilterValues: _listingsModule.setMainFilterValues,
  setShowUnlocalizedListings: _listingsModule.setShowUnlocalizedListings,
  setShowNewlyReleasedApps: _listingsModule.setShowNewlyReleasedApps
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _nuiIntlRuntime.withFormatter)(FilterBar));